(ns frontend.view.settings2.account-information.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:views :settings :account-information]))
(defonce state-atom (r/cursor state [:state-atom]))
